import { Component, OnInit } from '@angular/core';
import { FieldConfig } from 'src/app/core/interfaces/field-config';
import { UntypedFormGroup } from '@angular/forms';
import { DynamicFormServiceService} from 'src/app/shared/services/dynamic-form-service.service';

@Component({
    selector: 'app-input-num-comp',
    templateUrl: './input-num-comp.component.html',
    styleUrls: ['./input-num-comp.component.scss'],
    standalone: false
})
export class InputNumCompComponent implements OnInit {

  constructor(private dynamicService: DynamicFormServiceService) { }
  field: FieldConfig;
  group: UntypedFormGroup;
  isRequired: boolean;
  maxNumber: number;
  retrictDecimal: string[] = ['NT', 'NTB', 'MAP', 'UTADPI'];
  maxNumberCodes: string[] = ['HGHT', 'GA'];
  isMaxNumberCodes: boolean;
  isRestrictDecimal: boolean;
  ngOnInit() {
    this.isRequired = this.dynamicService.checkHasRequired(this.field);
    this.isMaxNumberCodes = (this.maxNumberCodes.indexOf(this.field.labelCode) > -1) ? true : false;
    this.isRestrictDecimal = (this.retrictDecimal.indexOf(this.field.labelCode) > -1) ? true : false;
  }

  addZeroes(num) {
    if (num.indexOf('.') > -1) {
      return false;
    } else {
      this.group.get(this.field.labelCode).setValue(null);
      this.group.get(this.field.labelCode).setValue(num);
    }
  }

  validateDecimal(value): any {
    const t = value;
    if (value === '') { this.group.get(this.field.labelCode).setValue(null); } else {
      const decimal = (this.field.labelCode === 'UTADPI') ? 3 : 2;
      value = (t.indexOf('.') > -1) ?
      (t.substr(0, t.indexOf('.')) + t.substr(t.indexOf('.'), decimal)) : t;
      this.group.get(this.field.labelCode).setValue(value);
    }
  }

  addmaxNumber(value): any {
    value = value.slice(0, 4);
    this.group.get(this.field.labelCode).setValue(value);
  }
}
